const SAMPLE_RESPONSE = {
  response: [
    {
      success: true,
      courier_type: "Eparcel",
      service_level: "standard",
      quotes: [
        {
          price: 19.71,
          estimated_transit_time: "4 business days",
        },
      ],
    },
    {
      success: true,
      courier_type: "EparcelExpress",
      service_level: "express",
      quotes: [
        {
          price: 32.02,
          estimated_transit_time: "1 business day",
        },
      ],
    },
  ],
  count: 4,
};
class ShippingCalcToggle extends HTMLElement {
  connectedCallback() {
    // Capture optional selector for calculator (defaults to first .shipping-calculator)
    this.targetSelector = this.getAttribute("target") || ".shipping-calculator";
    // Make the host behave like a button
    if (!this.hasAttribute("role")) this.setAttribute("role", "button");
    if (!this.hasAttribute("tabindex")) this.setAttribute("tabindex", "0");
    // Adopt button styling class if not present
    if (!this.classList.contains("shipping-section__button")) {
      this.classList.add("shipping-section__button");
    }

    const isHidden = () => {
      const calc =
        this.querySelector(".shipping-calculator") ||
        document.querySelector(this.targetSelector);
      if (!calc) return false;
      return (
        calc.hasAttribute("hidden") ||
        calc.classList.contains("hidden") ||
        calc.style.display === "none"
      );
    };

    this._onClick = (e) => {
      // Only intercept the click to reveal when calculator is hidden
      if (isHidden()) {
        e.preventDefault();
        this.showCalculator();
      }
      // If visible, do nothing so inner buttons/forms work normally
    };
    this._onKeyDown = (e) => {
      if ((e.key === "Enter" || e.key === " ") && isHidden()) {
        e.preventDefault();
        this.showCalculator();
      }
    };
    this.addEventListener("click", this._onClick);
    this.addEventListener("keydown", this._onKeyDown);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._onClick);
    this.removeEventListener("keydown", this._onKeyDown);
  }

  showCalculator() {
    // Prefer an inline calculator inside this element
    let calc = this.querySelector(".shipping-calculator");
    if (!calc) {
      calc = document.querySelector(this.targetSelector);
    }
    if (!calc) return;

    // Unhide if hidden via attribute/class/inline style
    calc.removeAttribute("hidden");
    calc.classList.remove("hidden");
    if (calc.style && calc.style.display === "none") calc.style.display = "";
    calc.classList.add("is-visible");

    // Mark host as open and update accessibility
    this.classList.add("is-open");
    this.setAttribute("aria-expanded", "true");

    // Focus input without scrolling the page
    const localInput = this.querySelector(".shipping-calculator-input");
    const globalInput = calc.querySelector?.(".shipping-calculator-input");
    const input = localInput || globalInput;
    try {
      input?.focus({ preventScroll: true });
    } catch (e) {
      /* no-op */
    }

    // Bind submit to look up suburb/state from AusPost (best-effort; falls back to opening their site)
    const form = (calc || this).querySelector(".shipping-calculator-form");
    const results = (calc || this).querySelector(".shipping-results");
    if (form) {
      form.addEventListener(
        "submit",
        async (ev) => {
          ev.preventDefault();
          const pc =
            input && typeof input.value === "string" ? input.value.trim() : "";

          if (results) {
            if (pc.length === 4) {
              // Assume SAMPLE_RESPONSE has the structure:
              // { response: [{ service_level, courier_type, quotes: [{ price, estimated_transit_time }, ...] }...], count: number }
              const endpoint =
                `${window.location.origin}/apps/datajet/task/690b3f49005e971604438cc2`;
              const weight = (parseInt(this.dataset.weight) || 1000) / 1000;
              const width = (parseInt(this.dataset.width) || 0) / 100;
              const height = (parseInt(this.dataset.height) || 0) / 100;
              const depth = (parseInt(this.dataset.depth) || 0) / 100;

              // Button loading state helpers
              const submitBtn = (calc || this).querySelector(
                ".shipping-calculator-button"
              );
              const spinner = submitBtn?.querySelector?.(".loading-spinner");
              const btnText = submitBtn?.querySelector?.(".button-text");
              const setLoading = (on) => {
                if (!submitBtn) return;
                if (on) {
                  submitBtn.classList.add("is-loading");
                  submitBtn.setAttribute("disabled", "");
                  if (spinner) spinner.style.display = "";
                  if (btnText) btnText.style.display = "none";
                } else {
                  submitBtn.classList.remove("is-loading");
                  submitBtn.removeAttribute("disabled");
                  if (spinner) spinner.style.display = "none";
                  if (btnText) btnText.style.display = "block";
                }
              };

              // Perform the POST call
              setLoading(true);
              fetch(endpoint, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  token: "npajnt2e8r1g28ebu7ta600se2vq0pb6f",
                },
                body: JSON.stringify({
                  dropoff_postcode: pc,
                  weight,
                  width,
                  height,
                  depth,
                }),
              })
                .then((response) => response.json())
                .then((data) => {
                  if (
                    data &&
                    Array.isArray(data.response) &&
                    data.response.length > 0
                  ) {
                    results.innerHTML = data.response
                      .map((service) => {
                        const firstQuote = service.quotes && service.quotes[0];
                        if (!firstQuote) return "";
                        const serviceLevel =
                          typeof service.service_level === "string" && service.service_level.length
                            ? service.service_level.charAt(0).toUpperCase() + service.service_level.slice(1)
                            : "";
                        return `
                          <div class="shipping-result-row">
                            ${serviceLevel || service.service_level || ""}:</span>
                            <span class="result-value">
                              $${firstQuote.price.toFixed(2)}
                            </span>
                          </div>
                        `;
                      })
                      .join("");
                  } else {
                    results.innerHTML = `<div class="shipping-result-row error">No rates found for this postcode.</div>`;
                  }
                })
                .finally(() => setLoading(false))
                .catch((error) => {
                  console.error("Shipping API error:", error);
                  results.innerHTML = `<div class="shipping-result-row error">There was an error retrieving shipping rates.</div>`;
                });
            } else {
              results.innerHTML = `<div class="shipping-result-row error">Please enter a valid 4-digit Australian postcode.</div>`;
            }
          }
        },
        { passive: false }
      );
    }
  }
}

if (!customElements.get("shipping-calc-toggle")) {
  customElements.define("shipping-calc-toggle", ShippingCalcToggle);
}
